import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      blogs: [],
      views:[],
      categories:[],
      baseURL: 'https://gepres-blogs-server.herokuapp.com',
      showAdmin:false,
      showLogin:true,
      loading: true
    },
    getters: {
      reverseBlog: state => {
        state.blogs.sort((a, b) => new Date(a.date) - new Date(b.date))
        return state.blogs.reverse().slice(0, 10)
      },
      filterViews: state => {
        return state.views.slice(0, 3)
      }
    },
    mutations: {
      resultadoBlogs(state, blogs) {
        state.blogs = blogs
      },
      resultadoBlogsViews(state,blogs){
        state.views = blogs
      },
      resultadoCategory(state,categories){
        state.categories = categories
      }
    },
    actions: {
      async cargarDatos({
        commit
      }) {
        await Vue.axios.get(`${this.state.baseURL}/api/blogs/show`)
          .then(res => {   
            commit('resultadoBlogs', res.data)
            this.state.loading = false
          })
      },
      async cargarDatosViews({
        commit
      }) {
        await Vue.axios.get(`${this.state.baseURL}/api/blogs/views`)
          .then(res => {
            commit('resultadoBlogsViews', res.data)
          })
      },
      async cargarCategorias({ commit }) {
        await Vue.axios.get(`${this.state.baseURL}/api/category`)
          .then(res => {
            commit('resultadoCategory', res.data)
          })
      }
    }
})
